import { CheckName } from "../../types/incidentbanner.typer";
import incidents_nb from "../nb/incidents";

const incidents: typeof incidents_nb = {
  banner: {
    message_zero:
      "Vi har for augenblinken ustabilitet i applikasjonen. Vi jobbar med å løyse problemet.",
    message_one:
      "Vi har for augenblinken ustabilitet mot $t(services.{{service}}). Prøv igjen seinare.",
    message_other:
      "Vi har for augenblinken ustabilitet mot {{services, services_formatter}}. Prøv igjen seinare.",
  },
  services: {
    FREG: "folkeregisteret",
    BRREG: "brønnøysundregistrene",
    KARTVERKET: "kartverket",
    ALTINN: "altinn",
    VEGVESEN: "statens vegvesen",
  } satisfies Record<CheckName, string>,
  og: "og",
};

export default incidents;
